const clientSettings = state => state.clientSettings;

export default clientSettings;
